const sortBy = (...keys) => (a, b) =>
  keys.map(key =>
    (a[key]?.toLowerCase?.() ?? a[key]) < (b[key]?.toLowerCase?.() ?? b[key])
      ? -1
      : (b[key]?.toLowerCase?.() ?? b[key]) < (a[key]?.toLowerCase?.() ?? a[key])
        ? 1
        : 0
  ).find(r => r) || 0;

export default sortBy;